export enum DocumentSource {
  Upload = 'Upload',
  InboundFaxes = 'Inbound Faxes',
}
